import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { LEGEND_LEFT_PADDING, LEGEND_TOP_PADDING } from '../../consts';
const SVGLegendLayer = (props) => {
    const { children, className, leftPadding = LEGEND_LEFT_PADDING, topPadding = LEGEND_TOP_PADDING, } = props;
    return (_jsx("g", Object.assign({ className: className, style: { transform: `translate(${leftPadding}px, ${topPadding}px)` } }, { children: children }), void 0));
};
export default memo(SVGLegendLayer);
